module.exports = ".next-tree {\n  margin-left: 10px;\n  cursor: default; }\n\n.menu-item-next-text {\n  cursor: pointer;\n  transition: .3s; }\n  .menu-item-next-text:hover {\n    color: #02adc6;\n    text-decoration: underline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/menu/menu.component.scss
// module id = 112
// module chunks = 1